import { Component, OnInit } from '@angular/core';
import { SessionService } from '../Services/Session/session-service.service';
import { MessageService} from 'primeng/api';
import { HttpRequest } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import {environment} from '../../environments/environment';
import { jsPDF } from "jspdf";
import {FirebaseService} from '../Services/Firebase/firebase.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-new-claim',
  templateUrl: './new-claim.component.html',
  styleUrls: ['./new-claim.component.css']
})
export class NewClaimComponent implements OnInit {

  constructor(private messageService: MessageService, private session: SessionService, private https: HttpClient, private Rc: FirebaseService, private router: Router) { }

  dependents: any = [];
  items: any = [];
  selectedDependent: any;
  selectedType: any;
  blob:any = [];
  imgSelected: boolean;
  pdfSelected: boolean;
  blobPdf:any = [];
  env = environment;
  loading: boolean = false;
  ownerName: any;
  firstView: boolean = false;
  hospitalization: boolean = false;
  success: boolean = false;
  welcomeText: string = '';
  hospitalizationText: string = '';
  idTransApp: string = '';
  ownerCompleteCardNumber: string = '';

  ngOnInit(): void {
    this.Rc.fetchActivate().then(() => {
      this.welcomeText = this.Rc.getStringRC('help_authorization_ios_value');
      this.hospitalizationText = this.Rc.getStringRC('global_hospital_forms');
    });
    const arrayDepends = JSON.parse(this.session.getParam('user')+"");
    this.ownerName = arrayDepends.policyOwnerCompleteName;
    this.dependents = arrayDepends.dependents;    
    this.selectedDependent = this.dependents[0];
    this.ownerCompleteCardNumber = arrayDepends.policyOwnerCompleteCardNumber;
    this.imgSelected = false;
    this.pdfSelected = false;
    this.showDialog();
    console.log("this.env.usrHN: "+ this.env.usrHN);
    if ( this.env.usrHN ) {
      this.items = [
        {
          id: 2,
          name: "Hospitalizacion"
        }
      ];
    } else {
      this.items = [
        {
          id: 0,
          name: "Medicamentos"
        },
        {
          id: 1,
          name: "Procedimiento Especial"
        },
        {
          id: 2,
          name: "Hospitalizacion"
        }
      ];
    }
    this.selectedType = this.items[0];
  }

  async customUpload(files:any, form) {
    const ccode = await this.session.getvvalueSession('data', 'countryCode');
    const url = this.env.urlEnvironment+'/insured-access-web/api/v1/digitalSendPDF';
    //let uploadUrl: string = url+"?policyCountryCode="+ccode+"&policyCardNumber="+this.selectedDependent.policyHolderCompleteCardNumber+"&policyCardNumberOwner="+this.selectedDependent.policyHolderCompleteCardNumber+"&type=PRE&name=RPNWEB&portal=RPN&total=0&typeAutorization="+this.selectedType.name+'&SO=Web';
    let uploadUrl: string = url+"?policyCountryCode="+ccode+"&policyCardNumber="+this.ownerCompleteCardNumber+"&policyCardNumberOwner="+this.ownerCompleteCardNumber+"&type=REE&name="+this.selectedDependent.policyHolderCompleteName+"&portal=RPN&total=0&typeAutorization=Reembolso";
    this.loading = true;
    console.log("loading: "+ this.loading);
    var xhr = new XMLHttpRequest();
    const data: FormData = new FormData();
    
    setTimeout(() => {
      files.map((file) => {
        data.append('file', file);  
      });
      xhr.open('POST', uploadUrl, true);
      xhr.send(data);
      xhr.onprogress = () => {
        this.loading = true;
      }
      xhr.onreadystatechange = () => {
        this.loading = false;
        if (xhr.readyState === 4) {
          console.log(xhr.response);
          if (xhr.response == undefined || xhr.response == '' ) {
            console.log(xhr.response);
            this.loading = false;
            this.messageService.clear();
            this.messageService.add({severity: 'error', summary: 'error', detail: 'Hubo un error en la petición, por favor validar peso de documentos no exceda a 50 MB e intente más tarde.', sticky: false});
            form.clear();
          } else {
            let response:any = JSON.parse(xhr.response)
            console.log(response);
            this.idTransApp = response.idTransApp;
            console.log(this.idTransApp);
            this.loading = false;
            this.success = true;
            form.clear();
          }
        }
      }
    }, 200);
  }

  async customUploadImg(files:any, form) {
    let doc = new jsPDF("l", "mm", [288, 288], true);
    let text = this.selectedDependent.policyHolderCompleteCardNumber+ "\n"+ this.selectedDependent.policyHolderCompleteName + "\n" + this.ownerName + "\n"+ this.selectedType.name;
    
    doc.text(text, 10, 150);

    const ccode = await this.session.getvvalueSession('data', 'countryCode');
    const url = this.env.urlEnvironment+'/insured-access-web/api/v1/digitalSendPDF';
    
    let uploadUrl: string = url+"?policyCountryCode="+ccode+"&policyCardNumber="+this.ownerCompleteCardNumber+"&policyCardNumberOwner="+this.ownerCompleteCardNumber+"&type=REE&name="+this.selectedDependent.policyHolderCompleteName+"&portal=RPN&total=0&typeAutorization=Reembolso";
    this.loading = true;
    var xhr = new XMLHttpRequest();
    let base64:any;
    
    let posX = 0;
    let posY = 0;
    files.map(async (file, index = 0) =>  {

    
      let fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = (async () => {
        
        base64 = fileReader.result.toString().split(",")[1];
        doc.addPage("a4","p");
        doc.addImage(
          base64,
            file.type,
            0,
            0,
            216,
            279
           );
        });
        posY += 20;
        posX += 10;
        index++;
    });

    setTimeout(() => {
      var file = doc.output('blob');
      
      //doc.save("merge.pdf");
      const data: FormData = new FormData(); 
      data.append('mypdf',file);
      xhr.open('POST', uploadUrl, true);
      xhr.send(data);
      xhr.onprogress = () => {
        this.loading = true;
      }
      xhr.onreadystatechange = () => {
        console.log("state: "+ xhr.readyState);
        this.loading = false;
        if (xhr.readyState === 4) {
          console.log(xhr.response);
          if (xhr.response == undefined || xhr.response == '' ) {
            console.log(xhr.response);
            this.loading = false;
            this.messageService.clear();
            this.messageService.add({severity: 'error', summary: 'error', detail: 'Hubo un error en la petición, por favor validar peso de documentos no exceda a 50 MB e intente más tarde.', sticky: false});
            form.clear();
          } else {
            let response:any = JSON.parse(xhr.response)
            console.log(response);
            this.idTransApp = response.idTransApp;
            console.log(this.idTransApp);
            this.loading = false;
            this.success = true;
            form.clear();
          }
        }

      };
    }, 200)
    
  }

  navigateComponent(url: string) {
    switch (url) {
      case 'providers': {
        this.router.navigate(['home/providers']);
        break;
      }
      case 'renovations': {
        this.router.navigate(['home/providers']);
        break;
      }
      case 'coupons': {
        this.router.navigate(['home/coupons']);
        break;
      }
      case 'authorizations': {
        this.router.navigate(['home/content']);
        break;
      }
    }
  }


pushFileToStorage(file: any) {  
  console.log("entra a pushFile");
  let uploadUrl: string = "https://stgeia.mediprocesos.com/insured-access-web/api/v1/digitalSendPDF?policyCountryCode=502&policyCardNumber="+this.selectedDependent.policyHolderCompleteCardNumber+"&policyCardNumberOwner="+this.selectedDependent.policyHolderCompleteCardNumber+"&type=PRE&name=RPNWEB&portal=RPN&total=0&typeAutorization=Medicamentos&SO=Web";  
  const data: FormData = new FormData();    
  data.append('file', file[0]);    
  const newRequest = new HttpRequest('POST', uploadUrl, data, {
    reportProgress: true,
    responseType: 'text'
    });    
    this.https.request(newRequest);
}

showDialog () {
  this.firstView = true;
}

showDialog2 () {
  this.hospitalization = true;
}

validate(event) {
  console.log("selected: "+ this.selectedType.name);
  if (this.selectedType.name == 'Hospitalización') {
    this.showDialog2();
  }
}

}
